import { useState } from 'react';

import { useStaticData } from 'libs/data-access';
import { IStaticMaster } from 'libs/data-access/types';

export default function useStaticMaster() {

    const {
        getStaticData,
        getUnsecureStaticData
    } = useStaticData();


    const [dropdownLists, setDropdownLists] = useState<{ [key: string]: IStaticMaster[] }>({});
    const [loadingStates, setLoadingStates] = useState<{ [key: string]: boolean }>({
        "search-type": false,
        "travel-type": false,
        "commission-form-charges": false,
        "markup-form-charges": false,
        "hotel-categories": false,
        "hotel-suppliers": false,
        "hotel/charge-apply-for": false,
        "flight/charge-apply-for": false,
        "flight/apply-type": false
    });
    const [apiDataLoaded, setApiDataLoaded] = useState(false);


    // HANDLER FUNCTION
    const getMethod = async (
        type: string,
        isStatic?: boolean,
        isUnsecure?: boolean
    ) => {
        if (isStatic) {
            if (isUnsecure) {
                return getUnsecureStaticData(type);
            } else {
                return getStaticData(type);
            };
        }
        //  else {
        //     if (isUnsecure) {
        //         return getUnsecureDropdownData(type);
        //     } else {
        //         return getDropdownData(type);
        //     };
        // };
    };


    // API CALL
    const fetchDropdownData = async (
        type: string,
        isStatic?: boolean,
        isUnsecure?: boolean
    ) => {
        setLoadingStates(prev => ({ ...prev, [type]: true }));
        setApiDataLoaded(false);

        try {
            const res = await getMethod(type, isStatic, isUnsecure);

            if (res?.isSuccess) {
                setApiDataLoaded(true);
                let data: IStaticMaster[] = res?.data?.data;
                console.log(`Fetched ${type}:`, data);
                setDropdownLists(prevState => ({
                    ...prevState,
                    [type]: data,
                }));
                return data;
            } else {
                setApiDataLoaded(true);
                return [];
            }
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            setApiDataLoaded(true);
            return [];
        } finally {
            setApiDataLoaded(true);
            setLoadingStates(prev => ({ ...prev, [type]: false }));
        };
    };


    const getSearchType = async () => fetchDropdownData('search-type', true);
    const getTravelType = async () => fetchDropdownData('travel-type', true);
    const getCommissionFormCharges = async () => fetchDropdownData('commission-form-charges', true);
    const getMarkupFormCharges = async () => fetchDropdownData('markup-form-charges', true);
    const getHotelCategories = async () => fetchDropdownData('hotel-categories', true);
    const getHotelSuppliers = async () => fetchDropdownData('hotel-suppliers', true);
    const getHotelChargeApplyFor = async () => fetchDropdownData('hotel/charge-apply-for', true);
    const getFlightChargeApplyFor = async () => fetchDropdownData('flight/charge-apply-for', true);
    const getFlightApplyType = async () => fetchDropdownData('flight/apply-type', true);


    // access the dropdown data
    const searchTypeDropdown = dropdownLists['search-type'] || [];
    const travelTypeDropdown = dropdownLists['travel-type'] || [];
    const commissionFormChargesDropdown = dropdownLists['commission-form-charges'] || [];
    const markupFormChargesDropdown = dropdownLists['markup-form-charges'] || [];
    const hotelCategoriesDropdown = dropdownLists['hotel-categories'] || [];
    const hotelSuppliersDropdown = dropdownLists['hotel-suppliers'] || [];
    const hotelChargeApplyForDropdown = dropdownLists['hotel/charge-apply-for'] || [];
    const flightChargeApplyForDropdown = dropdownLists['flight/charge-apply-for'] || [];
    const flightApplyTypeDropdown = dropdownLists['flight/apply-type'] || [];
    

    // access the loading state
    const isLoadingSearchType = loadingStates['search-type'];
    const isLoadingTravelType = loadingStates['travel-type'];
    const isLoadingCommissionFormCharges = loadingStates['commission-form-charges'];
    const isLoadingMarkupFormCharges = loadingStates['markup-form-charges'];
    const isLoadingHotelCategories = loadingStates['hotel-categories'];
    const isLoadingHotelSuppliers = loadingStates['hotel-suppliers'];
    const isLoadingHotelChargeApplyFor = loadingStates['hotel/charge-apply-for'];
    const isLoadingFlightChargeApplyFor = loadingStates['flight/charge-apply-for'];
    const isLoadingFlightApplyType = loadingStates['flight/apply-type'];


    return {
        apiDataLoaded,

        getSearchType,
        searchTypeDropdown,
        isLoadingSearchType,
        getTravelType,
        travelTypeDropdown,
        isLoadingTravelType,
        getCommissionFormCharges,
        commissionFormChargesDropdown,
        isLoadingCommissionFormCharges,
        getMarkupFormCharges,
        markupFormChargesDropdown,
        isLoadingMarkupFormCharges,
        getHotelCategories,
        hotelCategoriesDropdown,
        isLoadingHotelCategories,
        getHotelSuppliers,
        hotelSuppliersDropdown,
        isLoadingHotelSuppliers,
        getHotelChargeApplyFor,
        hotelChargeApplyForDropdown,
        isLoadingHotelChargeApplyFor,
        getFlightChargeApplyFor,
        flightChargeApplyForDropdown,
        isLoadingFlightChargeApplyFor,
        getFlightApplyType,
        flightApplyTypeDropdown,
        isLoadingFlightApplyType
    };

};